import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import { Textarea } from '@/components/ui/Textarea';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DESCRIBE_DAMAGE_NAME = 'describe_damage';

interface Props {
  name?: string;
}

export const TextareaDescribeDamage: FC<Props> = ({
  name = DESCRIBE_DAMAGE_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Opisz szkodę (nieobowiązkowe)')}</FormLabel>
          <InstructionHint
            title={i18n.t(
              'Opisz zdarzenie – co uległo uszkodzeniu i w jakich okolicznościach. Im dokładniej, tym lepiej. Wskaż rodzaj pomieszczenia (np. kuchnia, salon), jego przybliżone wymiary (np. kuchnia 3×4 m), oraz skalę szkody – np. 12 m² podłogi zalane, 20 m² uszkodzonego dachu, 15 m² sufitu do malowania.'
            )}
          />
          <FormControl>
            <Textarea
              placeholder={i18n.t('Wpisz...')}
              success={!!field.value}
              data-testid={`${name}-textarea`}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
